import { Button, MenuButton, MoreIcon } from "@fluentui/react-northstar";
import { forwardRef, useImperativeHandle, useState } from "react";

const MenuButtonComponent = forwardRef(
    ({ archiver, activeTab, menu, user }, ref) => {
        const [open, setOpen] = useState(false);

        useImperativeHandle(ref, () => ({
            closeMenu: () => setOpen(false), // 👈 Expose cette méthode au parent
        }));

        return (
            <MenuButton
                position="before"
                open={open}
                on="click"
                onOpenChange={(e, { open }) => {
                    e.stopPropagation();
                    if (archiver) return;
                    setOpen(open);
                }}
                trigger={
                    <Button
                        flat
                        iconOnly
                        icon={<MoreIcon />}
                        title="Open MenuButton"
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            setOpen(true);
                        }}
                    />
                }
                menu={menu(activeTab, user)}
            />
        );
    }
);

// ✅ Fix: Ajouter un displayName pour éviter les warnings dans React DevTools
MenuButtonComponent.displayName = "MenuButtonComponent";

export default MenuButtonComponent; // 👈 On exporte directement
